import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { AppBundle } from 'api/optimalprint-sdk.d';
import { AppDispatch, Store } from 'store';
import { setAbstractProductAction, setInitialCurrentProductAction, setLoadingProductsAction } from '../slice';
import fetchPublicAssetProductPrices from './fetchPublicAssetProductPrices';

const fetchAbstractProduct = async (productId: number, sourceImageId: string, source: string) => {
  const product = (await apiRequest(
    endpoints.productV2AbstractProductGet,
    { productId, source, sourceImageId },
    'GET',
    'data',
  )) as AppBundle.Api.Response.Product.V2.IProductAbstractProductGetV2Response;
  return product.abstractProduct;
};

const fetchAbstractProductOperation =
  (productId: number, slug: string) => async (dispatch: AppDispatch, getState: () => Store) => {
    const store = getState();

    // Check if we already fetched this product
    let product = store.publicAssetProduct.abstractProducts[slug];

    if (!product) {
      dispatch(setLoadingProductsAction(true));
      product = await fetchAbstractProduct(
        productId,
        store.publicAssetProduct.sourceImageId,
        store.publicAssetProduct.source,
      );
      dispatch(setLoadingProductsAction(false));
    }
    dispatch(setAbstractProductAction(product));
    dispatch(setInitialCurrentProductAction(product));
    dispatch(fetchPublicAssetProductPrices());
  };

export default fetchAbstractProductOperation;
